import { pages } from "@root/vue.config";

export const title = pages.index.title;
